var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExternalLinkIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.05 1.575C16.2 1.65 16.35 1.8 16.425 1.95C16.5 2.025 16.5 2.175 16.5 2.25V6.75C16.5 7.2 16.2 7.5 15.75 7.5C15.3 7.5 15 7.2 15 6.75V4.05L8.025 11.025C7.875 11.175 7.725 11.25 7.5 11.25C7.275 11.25 7.125 11.175 6.975 11.025C6.675 10.725 6.675 10.275 6.975 9.975L13.95 3H11.25C10.8 3 10.5 2.7 10.5 2.25C10.5 1.8 10.8 1.5 11.25 1.5H15.75C15.825 1.5 15.975 1.5 16.05 1.575ZM14.25 14.25V9.75C14.25 9.3 13.95 9 13.5 9C13.05 9 12.75 9.3 12.75 9.75V14.25C12.75 14.7 12.45 15 12 15H3.75C3.3 15 3 14.7 3 14.25V6C3 5.55 3.3 5.25 3.75 5.25H8.25C8.7 5.25 9 4.95 9 4.5C9 4.05 8.7 3.75 8.25 3.75H3.75C2.475 3.75 1.5 4.725 1.5 6V14.25C1.5 15.525 2.475 16.5 3.75 16.5H12C13.275 16.5 14.25 15.525 14.25 14.25Z",
    fill: "#3876BB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10134_76454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 16,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.05 1.575C16.2 1.65 16.35 1.8 16.425 1.95C16.5 2.025 16.5 2.175 16.5 2.25V6.75C16.5 7.2 16.2 7.5 15.75 7.5C15.3 7.5 15 7.2 15 6.75V4.05L8.025 11.025C7.875 11.175 7.725 11.25 7.5 11.25C7.275 11.25 7.125 11.175 6.975 11.025C6.675 10.725 6.675 10.275 6.975 9.975L13.95 3H11.25C10.8 3 10.5 2.7 10.5 2.25C10.5 1.8 10.8 1.5 11.25 1.5H15.75C15.825 1.5 15.975 1.5 16.05 1.575ZM14.25 14.25V9.75C14.25 9.3 13.95 9 13.5 9C13.05 9 12.75 9.3 12.75 9.75V14.25C12.75 14.7 12.45 15 12 15H3.75C3.3 15 3 14.7 3 14.25V6C3 5.55 3.3 5.25 3.75 5.25H8.25C8.7 5.25 9 4.95 9 4.5C9 4.05 8.7 3.75 8.25 3.75H3.75C2.475 3.75 1.5 4.725 1.5 6V14.25C1.5 15.525 2.475 16.5 3.75 16.5H12C13.275 16.5 14.25 15.525 14.25 14.25Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10134_76454)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H18V18H0V0Z",
    fill: "#D8DFE5"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLinkIcon);
export default __webpack_public_path__ + "static/media/ExternalLinkIcon.4b8ab66a2e33188ae969901025ee38aa.svg";
export { ForwardRef as ReactComponent };